import { render } from "./PageNumber14.vue?vue&type=template&id=68852f54&scoped=true"
import script from "./PageNumber14.vue?vue&type=script&lang=js"
export * from "./PageNumber14.vue?vue&type=script&lang=js"

import "./PageNumber14.vue?vue&type=style&index=0&id=68852f54&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68852f54"]])

export default __exports__